"use client";

import { c as _c } from "react/compiler-runtime";
import { Menu, X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";
import { AuthLink } from "@/components/shared/auth-link";
import { useUser } from "@/hooks/useUser";
import { Button } from "@/lib/components/button";
import { useAppConfig } from "@/lib/config";
import Logo from "@/lib/icons/Logo";
import { cn } from "@/lib/utils";
import { ThemeToggle } from "./theme-toggle";
import type { ApiModel, ApiProvider } from "@/lib/fetch-models";
export const Navbar = t0 => {
  const $ = _c(27);
  const {
    sticky: t1
  } = t0;
  const sticky = t1 === undefined ? true : t1;
  useAppConfig();
  const {
    user,
    isLoading
  } = useUser();
  const isAuthenticated = !!user && !isLoading;
  const [menuState, setMenuState] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  const t4 = menuState && "active";
  const t5 = sticky && "fixed";
  let t6;
  if ($[2] !== t5) {
    t6 = cn("z-20 w-full px-2 group", t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = isScrolled && "bg-background/50 max-w-[1400px] rounded-2xl border backdrop-blur-lg lg:px-5";
  let t8;
  if ($[4] !== t7) {
    t8 = cn("mt-2 mx-auto max-w-[1400px] px-6 transition-all duration-300", t7);
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link href="/" aria-label="home" className="flex items-center space-x-2" prefetch={true}><Logo className="h-8 w-8 rounded-full text-black dark:text-white" /><span className="text-xl font-bold tracking-tight text-zinc-900 dark:text-white">LLM Gateway</span></Link>;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== menuState) {
    t10 = () => setMenuState(!menuState);
    $[7] = menuState;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = menuState ? "Close Menu" : "Open Menu";
  let t12;
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Menu className="group-data-[state=active]:scale-0 group-data-[state=active]:opacity-0 size-6 duration-200" />;
    t13 = <X className="absolute inset-0 m-auto size-6 -rotate-180 scale-0 opacity-0 group-data-[state=active]:rotate-0 group-data-[state=active]:scale-100 group-data-[state=active]:opacity-100 duration-200" />;
    $[9] = t12;
    $[10] = t13;
  } else {
    t12 = $[9];
    t13 = $[10];
  }
  let t14;
  if ($[11] !== t10 || $[12] !== t11) {
    t14 = <div className="flex w-full justify-between nav:w-auto">{t9}<button onClick={t10} aria-label={t11} className="relative z-20 -m-2.5 -mr-4 block cursor-pointer p-2.5 nav:hidden">{t12}{t13}</button></div>;
    $[11] = t10;
    $[12] = t11;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ThemeToggle />;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== isAuthenticated) {
    t16 = <div className="bg-background group-data-[state=active]:block nav:group-data-[state=active]:flex mb-6 hidden w-full flex-wrap items-center justify-end space-y-8 rounded-3xl border p-6 shadow-2xl shadow-zinc-300/20 md:flex-nowrap nav:m-0 nav:flex nav:w-fit nav:shrink-0 nav:gap-3 nav:space-y-0 nav:border-transparent nav:bg-transparent nav:p-0 nav:shadow-none dark:shadow-none dark:nav:bg-transparent"><div className="flex w-full flex-col space-y-3 sm:flex-row sm:gap-3 sm:space-y-0 md:w-fit items-center">{t15}{isAuthenticated ? <Button asChild={true} className="bg-zinc-900 dark:bg-white text-white dark:text-black hover:bg-zinc-700 dark:hover:bg-zinc-200 font-medium w-full md:w-fit"><Link href="/dashboard" prefetch={true}>Dashboard</Link></Button> : <><Link href="/login" prefetch={true} className="text-sm text-muted-foreground hover:text-foreground transition-colors hidden nav:block whitespace-nowrap">Log In</Link><Button asChild={true} className="bg-zinc-900 dark:bg-white text-white dark:text-black hover:bg-zinc-700 dark:hover:bg-zinc-200 font-medium w-full md:w-fit"><AuthLink href="/signup">Get Started</AuthLink></Button></>}</div></div>;
    $[15] = isAuthenticated;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== t14 || $[18] !== t16) {
    t17 = <div className="relative flex flex-wrap items-center justify-between gap-6 py-3 nav:flex-nowrap nav:gap-0 nav:py-4">{t14}{t16}</div>;
    $[17] = t14;
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== t17 || $[21] !== t8) {
    t18 = <div className={t8}>{t17}</div>;
    $[20] = t17;
    $[21] = t8;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t18 || $[24] !== t4 || $[25] !== t6) {
    t19 = <header><nav data-state={t4} className={t6}>{t18}</nav></header>;
    $[23] = t18;
    $[24] = t4;
    $[25] = t6;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  return t19;
};